import { DimensionIds } from "model/reporterDb/dbTableCampaign";
import { DimensionIds as TrafficDimensionIds } from "model/reporterDb/dbTableTraffic";

//TODO why this exists?
export const CAMPAIGN_ID_DIMENSION = {
  type: "Dimension",
  id: "CAMPAIGN_ID",
  name: "Campaign Id",
};

export const LINEITEM_ID_DIMENSION = {
  type: "Dimension",
  id: "LINEITEM_ID",
  name: "Lineitem id",
};

export const APP_BUNDLE_DIMENSION = {
  id: DimensionIds.APP_BUNDLE_COLUMN_ID,
  name: "App Bundle ID",
  type: "Dimension",
};

export const TAG_ID_DIMENSION = {
  id: TrafficDimensionIds.TAG_ID,
  name: "Tag ID",
  type: "Dimension",
};

export const CAMPAIGN_BUNDLE_DIMENSION = {
  id: DimensionIds.CAMPAIGN_BUNDLE_COLUMN_ID,
  name: "Campaign Bundle ID",
  type: "Dimension",
};
